import { Link } from 'react-router-dom'
import { Box, Tooltip } from '@mui/material'
import { classNames } from '../../utils/Utils'
import { useColorModeContext } from '../../context/ColorModeContext'

const TrackingProjectUrl = ({ data }) => {
  const { mode } = useColorModeContext()

  if (!data) {
    return
  }

  const url = data.url
  const MAX_VISIBLE_CHARACTERS = 50

  return (
    <Box sx={{ display: 'flex', mt: 1 }}>
      <div className='KeywordRedirectLink'>
        <Tooltip title={url} arrow followCursor>
          <Link to={`/tracking/keywords/?q=${data.id}`} relative='path' className={classNames(mode)}>
            {url.length > MAX_VISIBLE_CHARACTERS ? `${url.substring(0, MAX_VISIBLE_CHARACTERS)}...` : url}
          </Link>
        </Tooltip>
      </div>
    </Box>
  )
}

export default TrackingProjectUrl
